import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function useMediaQuery({ maxWidth = 700 }) {
    const [larger, setLarger] = useState(false);
    const [smaller, setSmaller] = useState(false);

    useEffect(() => {
        // Create a MediaQueryList object
        const mediaQuery = window.matchMedia(`(max-width: ${maxWidth}px)`);
        // Call listener function at run time
        const handler = () => {
            if (mediaQuery.matches) {
                // If media query matches
                console.log('maxWidth-');
                setLarger(false);
                setSmaller(true);
            } else {
                console.log('maxWidth+');
                setSmaller(false);
                setLarger(true);
            }
        };
        // Attach listener function on state changes
        mediaQuery.addEventListener('change', handler);
        return () => {
            mediaQuery.removeEventListener('change', handler);
        };
    }, [maxWidth]);

    return { larger, smaller };
}

useMediaQuery.propTypes = {
    maxWidth: PropTypes.number,
};

export default useMediaQuery;
